// extracted by mini-css-extract-plugin
module.exports = {"publish":"publish_publish___xR05","confirmation_text":"publish_confirmation_text__R49IG"};